module.exports = __webpack_public_path__ + "7718c5539325a4c4a9b0ecc097545f73.png";


//////////////////
// WEBPACK FOOTER
// ./app/stylesheets/header/images/close-icon.png
// module id = 1099
// module chunks = 4